/* LUGAZI: the three fare-machine buttons under the waiting list at the end of BOOK.
   blue  PUSH TO JOIN  -> sends the e-mail (same as the drawn Join)
   red   TICKET        -> your number pops
   yellow INSTA GRAM   -> Instagram (only once a link is set in data-ig on the script tag)
   Remove this file (and its line in snippets/lugazi-hints.liquid) to undo. */
(function () {
  var me = document.currentScript; if (!me) return;
  var IMG = { red: me.dataset.red, blue: me.dataset.blue, yellow: me.dataset.yellow }, IG = me.dataset.ig || '';
  var css = document.createElement('style');
  css.textContent =
    '.lgz-machine{display:flex;justify-content:center;align-items:flex-end;gap:1.9%;width:min(92%,440px);margin:14px auto 6px}' +
    '.lgz-machine button{flex:none;display:block;margin:0;padding:0;border:0;background:none;cursor:pointer;-webkit-tap-highlight-color:transparent;' +
    'transition:transform .09s ease-out,filter .09s ease-out;touch-action:manipulation}' +
    '.lgz-machine button img{display:block;width:100%;height:auto;pointer-events:none;-webkit-user-drag:none;user-select:none}' +
    '.lgz-machine .lgz-m-red{width:41.4%}.lgz-machine .lgz-m-blue{width:27.3%}.lgz-machine .lgz-m-yellow{width:27.5%}' +
    '.lgz-machine button.is-press{transform:translateY(3px) scale(.985);filter:brightness(.9)}' +
    '.lgz-machine button:focus-visible{outline:1px dashed #000;outline-offset:4px}' +
    '.lgz-machine .lgz-m-yellow[aria-disabled="true"]{cursor:default}' +
    '.lgz-num.lgz-ping{animation:lgz-ping .5s cubic-bezier(.2,.9,.25,1.3)}' +
    '@keyframes lgz-ping{0%{transform:scale(1)}40%{transform:scale(1.25) rotate(-3deg)}100%{transform:scale(1)}}' +
    '.lwl-row.lgz-shake{animation:lgz-shake .46s cubic-bezier(.36,.07,.19,.97)}' +
    '@media (max-height:760px){.lgz-machine{width:min(64%,300px);margin:8px auto 2px}}' +
    '@media (max-height:700px){.lgz-machine{width:min(50%,240px);margin:4px auto 0}}' +
    '@media (max-height:620px){.lgz-machine{width:min(40%,200px);margin:2px auto 0}}' +
    '@media (max-width:749px) and (max-height:620px){body .lx-newpage .lwl.lwl-inpage{width:min(84%,38svh)!important}}' +
    '@media (prefers-reduced-motion:reduce){.lgz-machine button{transition:none}.lgz-num.lgz-ping,.lwl-row.lgz-shake{animation:none}}';
  document.head.appendChild(css);

  function press(b) {
    b.classList.add('is-press');
    setTimeout(function () { b.classList.remove('is-press'); }, 140);
  }
  var SIZE = { red: [360, 427], blue: [250, 439], yellow: [250, 438] };
  function make(cls, src, label, k) {
    var b = document.createElement('button'); b.type = 'button'; b.className = cls; b.setAttribute('aria-label', label);
    var i = document.createElement('img'); i.src = src; i.alt = ''; i.decoding = 'async'; i.width = SIZE[k][0]; i.height = SIZE[k][1]; b.appendChild(i);
    b.addEventListener('pointerdown', function () { b.classList.add('is-press'); });
    ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) { b.addEventListener(ev, function () { b.classList.remove('is-press'); }); });
    return b;
  }
  function build() {
    var page = document.querySelector('.lx-newpage'); if (!page || page.querySelector('.lgz-machine')) return;
    var form = page.querySelector('.lwl-form'), field = form && form.querySelector('.lwl-hfield'); if (!field) return;
    var row = document.createElement('div'); row.className = 'lgz-machine';
    var red = make('lgz-m-red', IMG.red, 'Your number', 'red');
    var blue = make('lgz-m-blue', IMG.blue, 'Join the list', 'blue');
    var yellow = make('lgz-m-yellow', IMG.yellow, 'Instagram', 'yellow');
    if (!IG) yellow.setAttribute('aria-disabled', 'true');
    row.appendChild(red); row.appendChild(blue); row.appendChild(yellow);
    var after = form.querySelector('.lgz-num') || field;
    after.after(row);

    blue.addEventListener('click', function () {
      press(blue);
      var email = form.querySelector('.lwl-email'), go = form.querySelector('.lwl-submit');
      if (email && !email.value.trim()) {           /* nothing typed yet: show where to type */
        field.classList.remove('lgz-shake'); void field.offsetWidth; field.classList.add('lgz-shake');
        email.focus({ preventScroll: true });
        return;
      }
      if (form.requestSubmit) form.requestSubmit(go || undefined); else if (go) go.click();
    });
    red.addEventListener('click', function () {
      press(red);
      var n = form.querySelector('.lgz-num') || page.querySelector('.lgz-num'); if (!n) return;
      n.classList.remove('lgz-ping'); void n.offsetWidth; n.classList.add('lgz-ping');
    });
    yellow.addEventListener('click', function () {
      press(yellow);
      if (IG) window.open(IG, '_blank', 'noopener');
    });
    /* the machine changes the height of the book's end - let the sideways chapter and the logo measure again */
    setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 60);
  }
  var n = 0, iv = setInterval(function () {
    if (document.body.dataset.lugaziView === 'book') build();
    if (document.querySelector('.lgz-machine') || ++n > 120) clearInterval(iv);
  }, 500);
})();
